import LocalizedStrings from 'localized-strings';

import { TaskType } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    [TaskType.Product]: 'Product',
    [TaskType.Service]: 'Service',
  },
  fr: {
    [TaskType.Product]: 'Produit',
    [TaskType.Service]: 'Service',
  },
} as const);

export default locales;
